import { Deposit } from '../models/deposit';
import { User } from '../models/user';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { GLOBAL } from './global.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { UserFilter } from '../models/user';

@Injectable({providedIn: 'root'})
export class UserService {
    public url: string;
    public identity;
    public token;
    public service: string = 'userService';

    constructor(
        private _http: HttpClient
    ) {
        this.url = GLOBAL.url;
    }

    login(loginRequest) {
        const body = JSON.stringify(loginRequest);
        return this._http.post(this.url + 'loginService/loginCustomer2X',
            body,
            { responseType: 'text', observe: 'response', headers: new HttpHeaders() }
        ).pipe(map(
            res => res
        ));
    }

    getIdentity() {
        const identity = JSON.parse(localStorage.getItem('login'));
        if (identity !== 'undefined' && identity != null) {
            this.identity = identity;
            return this.identity.customer;    
        } 
        return null;                           
    }

    getToken() {
        const token = localStorage.getItem('token');
        if (token !== 'undefined' && token != null) {
            this.token = token;
        } else {
            this.token = null;
        }
        return this.token;
    }

    getUserList(page, user: UserFilter) {
        let params: HttpParams = new HttpParams();
        if (user.name) {
            params = params.set('name', user.name);
        }
        return this._http.get(this.url + this.service + '/getUserList/' + page,
            { responseType: 'text', observe: 'response', headers: new HttpHeaders(), params: params }).pipe(map(res => {
                return res
            }));
    }

    getStorageFilterList() {
        return localStorage.getItem('users-filter-list');
    }

    save(user) {
        let body = JSON.stringify(user);
        return this._http.post(this.url + this.service, body, { observe: 'response', headers: new HttpHeaders() }
        ).pipe(map(
            res => res
        ));
    }

    getRoles(page) {
        let params: HttpParams = new HttpParams();
        return this._http.get(this.url + this.service + '/getRoles/' + page,
            { responseType: 'text', observe: 'response', headers: new HttpHeaders(), params: params }).pipe(map(res => {
                return res
            }));
    }

    getUser(idUser) {
        return this._http.get(this.url + this.service + '/' + idUser,
            { responseType: 'text', observe: 'response', headers: new HttpHeaders() }).pipe(map(res => {
              return res
            }));
    }

    update(user) {
        let body = JSON.stringify(user);
        return this._http.put(this.url + this.service, body, { observe: 'response', headers: new HttpHeaders() }
        ).pipe(map(
            res => res
        ));
    }

    userBranchToFind(user: User):string{
        let branchToFind: string;
        branchToFind = '';
        for (let branch of user.branches) {
           branchToFind += "'" + branch.id + "',"; 
        }
        branchToFind = branchToFind.substring(0, branchToFind.length-1);
        return branchToFind;
    }

    getDepositUser(): Deposit[]{
        let user: User = this.getIdentity();
        let deposits: Deposit[] = [];
        for (let branch of user.branches){
            for (let depositBranch of branch.deposits){
                if (!deposits.some(d => d.id === depositBranch.id)) {
                    deposits.push(depositBranch);        
                }
            }
        }
        return deposits;
    }
}
